import { useState } from "react";
import { Link } from "react-router-dom";
import api, { formatApiErrorDetail } from "../lib/api";
import { Logo } from "../components/Logo";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { Loader2, ArrowLeft, MailCheck } from "lucide-react";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
    } catch (e2) {
      setError(formatApiErrorDetail(e2.response?.data?.detail) || e2.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center p-6 bg-background">
      <div className="w-full max-w-md fade-up">
        <div className="mb-8"><Logo /></div>
        {sent ? (
          <div className="text-center">
            <MailCheck className="h-14 w-14 text-secondary mx-auto mb-4" strokeWidth={2} />
            <h2 className="font-heading text-3xl font-black uppercase tracking-tight">Check your email</h2>
            <p className="text-muted-foreground mt-3">If that email is registered, a reset link has been sent. It expires in 1 hour.</p>
            <Link to="/login" className="inline-flex items-center gap-2 mt-8 text-sm font-bold text-white hover:text-primary transition-colors">
              <ArrowLeft className="h-4 w-4" /> Back to sign in
            </Link>
          </div>
        ) : (
          <>
            <h2 className="font-heading text-4xl font-black uppercase tracking-tight mb-2">Reset password</h2>
            <p className="text-muted-foreground mb-8">Enter your email and we'll send a reset link.</p>
            <form onSubmit={submit} className="space-y-5">
              <div className="space-y-2">
                <Label className="text-xs font-bold uppercase tracking-widest text-muted-foreground">Email</Label>
                <Input data-testid="forgot-email-input" type="email" required value={email}
                  onChange={(e) => setEmail(e.target.value)} placeholder="you@team.com" className="h-12 bg-card border-border" />
              </div>
              {error && <p className="text-sm font-semibold text-primary">{error}</p>}
              <Button type="submit" data-testid="forgot-submit-button" disabled={loading}
                className="w-full h-12 bg-primary hover:bg-red-500 text-white font-heading font-bold uppercase tracking-widest transition-colors">
                {loading ? <Loader2 className="h-5 w-5 animate-spin" /> : "Send reset link"}
              </Button>
            </form>
            <Link to="/login" className="inline-flex items-center gap-2 mt-8 text-sm font-bold text-white hover:text-primary transition-colors">
              <ArrowLeft className="h-4 w-4" /> Back to sign in
            </Link>
          </>
        )}
      </div>
    </div>
  );
}
